import { HttpParams } from '@angular/common/http';
import { appendHttpParamsFromObject } from 'shared/util-common';

import { Sorting } from '@treetop/shared/model';

import { SmartbookFilter } from '../entities/filter';
import { Pagination } from '../entities/pagination';

export function createGuidelineParams(filter: SmartbookFilter, pagination: Pagination, sorting: Sorting): HttpParams {
  let params = new HttpParams();

  params = appendHttpParamsFromObject(pagination, params);
  params = appendHttpParamsFromObject(filter, params);

  if (sorting.order !== null) {
    params = params.append('field', sorting.field as number);
    params = params.append('order', sorting.order as number);
  }

  return params;
}
